import React from 'react';
import * as S from './styles';
const CountryModal = ({ open = false, closable = true, width = 'large', height = 'auto', content, actions, onClose, }) => (React.createElement(S.Modal, { open: open, onClose: closable && onClose, slots: { backdrop: S.StyledBackdrop }, "data-testid": "country-modal" },
    React.createElement(S.Container, { "$width": width, "$height": height },
        React.createElement(S.Content, null, content),
        actions && React.createElement(S.Actions, null, actions))));
export default CountryModal;
//# sourceMappingURL=CountryModal.js.map